import Hero from './hero';
import BackedBy from './backed-by';
import FeatureGrid from './feature-grid';
import KreateSomething from './kreate-something';
import RevMemeGeneration from './rev-meme-generation';
import UpcomingTools from './upcoming-tools';
// import Testimonial from './testimonial';
import AnimatePresence from 'components/ui/animate-presence';
import DreamSection from './dream-section';

export const Home = () => {
  return (
    <div className="bg-background-marketing">
      <AnimatePresence name="hero">
        <Hero />
      </AnimatePresence>
      <AnimatePresence name="kreate-something">
        <KreateSomething />
      </AnimatePresence>
      <AnimatePresence name="rev-meme-generation">
        <RevMemeGeneration />
      </AnimatePresence>
      <AnimatePresence name="feature-grid">
        <FeatureGrid />
      </AnimatePresence>
      <BackedBy />
      <AnimatePresence name="dream-section">
        <DreamSection />
      </AnimatePresence>
      {/* <AnimatePresence name="upcoming-tools">
        <UpcomingTools />
      </AnimatePresence> */}
      {/* <AnimatePresence name="testimonial">
        <Testimonial />
      </AnimatePresence> */}
      {/* <AnimatePresence name="blogs-section">
        <BlogsSection />
      </AnimatePresence> */}
    </div>
  );
};
